/**
 * Product page: thumbnail switching, hover zoom that follows the cursor,
 * variant price updates, quantity stepper, sticky add-to-bag on phones,
 * and the automatic "more from the table" recommendations.
 */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var stage = root.querySelector('[data-zoom]');
  var main = document.getElementById('product-main-image');
  var form = root.querySelector('[data-product-form]');
  var addButton = root.querySelector('[data-add]');
  var sticky = root.querySelector('[data-sticky]');

  // Thumbnails
  root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!main) return;
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Zoom follows the cursor on pointer devices only
  if (stage && main && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zooming');
      main.style.transformOrigin = '';
    });
    stage.addEventListener('mousemove', function (event) {
      var r = stage.getBoundingClientRect();
      var x = ((event.clientX - r.left) / r.width) * 100;
      var y = ((event.clientY - r.top) / r.height) * 100;
      main.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  // Variants: option pills -> matching variant
  var variantsEl = root.querySelector('[data-variants]');
  var idInput = root.querySelector('[data-variant-id]');
  if (variantsEl && idInput) {
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

    function selected() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }

    function markAvailability(values) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.pill-option').forEach(function (pill) {
          var input = pill.querySelector('input');
          var probe = values.slice();
          probe[idx] = input.value;
          var match = findVariant(probe);
          pill.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function apply() {
      var values = selected();
      var variant = findVariant(values);
      markAvailability(values);
      var label = root.querySelector('[data-add-label]');
      var price = root.querySelector('[data-price]');
      var stickyPrice = root.querySelector('[data-price-sticky]');
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (label) label.textContent = label.dataset.unavailable || label.textContent;
        return;
      }
      idInput.value = variant.id;
      var tpl = root.querySelector('[data-price-for="' + variant.id + '"]');
      if (tpl && price) price.innerHTML = tpl.innerHTML;
      if (stickyPrice) stickyPrice.textContent = (variant.price / 100).toLocaleString('en-IN', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'INR', maximumFractionDigits: 2 });
      if (addButton) addButton.disabled = !variant.available;
      var stickyAddBtn = root.querySelector('[data-sticky-add]');
      if (stickyAddBtn) stickyAddBtn.disabled = !variant.available;
      if (label) label.textContent = variant.available ? (label.dataset.add || label.textContent) : (label.dataset.soldOut || label.textContent);
      if (variant.featured_media && variant.featured_media.id) {
        var thumb = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-value]')) apply();
    });
    var initialLabel = root.querySelector('[data-add-label]');
    if (initialLabel) {
      initialLabel.dataset.add = initialLabel.dataset.add || '';
    }
    markAvailability(selected());
  }

  // Quantity stepper
  root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('product-quantity');
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
      input.value = next;
    });
  });

  // Sticky bar on phones
  if (sticky && addButton && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0 });
    io.observe(addButton);
    var stickyAdd = sticky.querySelector('[data-sticky-add]');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  // Recommendations
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.dataset.url) {
    fetch(rec.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.children.length) {
          rec.innerHTML = fresh.innerHTML;
          rec.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
        } else {
          rec.closest('.shopify-section').style.display = 'none';
        }
      })
      .catch(function () {});
  }
})();
